import * as React from 'react';

function SvgFileEarmarkMedicalFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M9.293 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4.707A1 1 0 0013.707 4L10 .293A1 1 0 009.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 01-1-1zm-3 2v.634l.549-.317a.5.5 0 11.5.866L7 7l.549.317a.5.5 0 11-.5.866L6.5 7.866V8.5a.5.5 0 01-1 0v-.634l-.549.317a.5.5 0 11-.5-.866L5 7l-.549-.317a.5.5 0 01.5-.866l.549.317V5.5a.5.5 0 111 0zm-2 4.5h5a.5.5 0 010 1h-5a.5.5 0 010-1zm0 2h5a.5.5 0 010 1h-5a.5.5 0 010-1z' />
		</svg>
	);
}

export default SvgFileEarmarkMedicalFill;
